export default "__VITE_ASSET__DbTBDQPJ__"